"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _possibleConstructorReturn = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var idlUtils = require("../generated/utils.js");

var DOMException = require("domexception");

var _require = require("../node-document-position"),
    DOCUMENT_POSITION_CONTAINS = _require.DOCUMENT_POSITION_CONTAINS,
    DOCUMENT_POSITION_CONTAINED_BY = _require.DOCUMENT_POSITION_CONTAINED_BY;

var Element = require("../generated/Element");

var Node = require("../generated/Node");

var HTMLCollectionImpl = require("./HTMLCollection-impl").implementation;

exports.implementation = /*#__PURE__*/function (_HTMLCollectionImpl) {
  _inherits(HTMLOptionsCollectionImpl, _HTMLCollectionImpl);

  var _super = _createSuper(HTMLOptionsCollectionImpl);

  function HTMLOptionsCollectionImpl() {
    _classCallCheck(this, HTMLOptionsCollectionImpl);

    return _super.apply(this, arguments);
  }

  _createClass(HTMLOptionsCollectionImpl, [{
    key: idlUtils.indexedSetNew,
    value: function value(index, _value) {
      if (_value === null) {
        this.remove(index);
        return;
      }

      this._update();

      var length = this._list.length;
      var n = index - length;

      if (n > 0) {
        var doc = this._element._ownerDocument;
        var frag = doc.createDocumentFragment(); // Spec says n - 1, but n seems to be the right number here.

        for (var i = 0; i < n; i++) {
          var el = doc.createElement("option");
          frag.appendChild(el);
        }

        this._element.appendChild(frag);
      }

      if (n >= 0) {
        this._element.appendChild(_value);
      } else {
        this._element.replaceChild(_value, this._list[index]);
      }
    }
  }, {
    key: idlUtils.indexedSetExisting,
    value: function value(index, _value2) {
      return this[idlUtils.indexedSetNew](index, _value2);
    }
  }, {
    key: "add",
    value: function add(element, before) {
      if (this._element.compareDocumentPosition(element) & DOCUMENT_POSITION_CONTAINS) {
        throw new DOMException("The operation would yield an incorrect node tree.", "HierarchyRequestError");
      }

      if (Element.isImpl(before) && !(this._element.compareDocumentPosition(before) & DOCUMENT_POSITION_CONTAINED_BY)) {
        throw new DOMException("The object can not be found here.", "NotFoundError");
      }

      if (element === before) {
        return;
      }

      var reference = null;

      if (Node.isImpl(before)) {
        reference = before;
      } else if (typeof before === "number") {
        this._update();

        reference = this._list[before] || null;
      }

      var parent = reference !== null ? reference.parentNode : this._element;
      parent.insertBefore(element, reference);
    }
  }, {
    key: "remove",
    value: function remove(index) {
      this._update();

      if (this._list.length === 0) {
        return;
      }

      if (index < 0 || index >= this._list.length) {
        return;
      }

      var element = this._list[index];
      element.parentNode.removeChild(element);
    }
  }, {
    key: "length",
    // inherits supported property indices
    get: function get() {
      this._update();

      return this._list.length;
    },
    set: function set(value) {
      this._update();

      if (value > this._list.length) {
        var doc = this._element._ownerDocument;

        for (var i = this._list.length; i < value; i++) {
          var el = doc.createElement("option");

          this._element.appendChild(el);
        }
      } else if (value < this._list.length) {
        for (var _i = this._list.length - 1; _i >= value; _i--) {
          var _el = this._list[_i];

          this._element.removeChild(_el);
        }
      }
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      this._update();

      var result = new Set();

      var _iterator = _createForOfIteratorHelper(this._list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;
          result.add(element.getAttribute("id"));
          result.add(element.getAttribute("name"));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return result;
    }
  }, {
    key: "selectedIndex",
    get: function get() {
      return this._element.selectedIndex;
    },
    set: function set(value) {
      this._element.selectedIndex = value;
    }
  }]);

  return HTMLOptionsCollectionImpl;
}(HTMLCollectionImpl);